<template>
  <div class="tokyo_tm_about">
    <div>
      <img src="../assets/img/slider/1.png" alt="about" />
    </div>
    <!-- End .about_image -->

    <div class="description">
      <h3 class="name">Juan Carlos Pineda / Web-Dev /  Graphic Designer</h3>
      <div class="description_inner">
        <div class="left">
          <p>
            Junior Front End Web Developer / Graphic Design / Marketing professional who 
            recently transitioned from 11 years of experience as Graphic Design and Marketing
             profesional. I have strong understanding of user experience and
            interface design. I am continuously learning about testing and debugging processes, and
            bring many years of expertise in design and I am equipped with a diverse and promising skill set.
          </p>
          <div class="tokyo_tm_button">
            <button class="ib-button" @click="showModal">Read More</button>
          </div>
        </div>
        <!-- End .left -->

        <div class="right">
          <ul>
            <li>
              <p><span>Address:</span>Sant Just Desvern / Barcelona</p>
            </li>
            <li>
              <p>
                <span>Email:</span
                ><a href="mailto:laggart@gmail.com">laggart@gmail.com</a>
              </p>
            </li>
            <li>
              <p><span>Freelance:</span>Available</p>
            </li>
          </ul>
          <!-- End ul -->
        </div>
        <!-- End .right -->
      </div>
    </div>

    <!-- Start Modalbox -->
    <transition name="fade">
      <!-- Modal -->
      <div
        :class="{ 'modal-mask': isActive }"
        id="modal"
        @click="closeModal"
        v-if="isVisible"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-user"
          @click.stop
        >
          <div class="modal-content">
            <div class="tokyo_tm_modalbox_about">
              <div class="close" @click="closeModal">
                <img
                  class="svg"
                  src="../assets/img/svg/cancel.svg"
                  alt="cancel-img"
                />
              </div>
              <!-- End .close -->
              <div class="my_box">
                <div class="left">
                  <div class="about_title">
                    <h3>Software Skills</h3>
                  </div>
                  <!-- End .abut_title -->
                  <div class="tokyo_progress">
                    <div class="progress_inner">
                      <span
                        ><span class="label">Photoshop</span
                        ><span class="number">85%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:85%"></div>
                        </div>
                      </div>
                    </div>
                    <!-- End progress_inner -->
                    <div class="progress_inner">
                      <span
                        ><span class="label">Illustrator</span
                        ><span class="number">85%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:85%"></div>
                        </div>
                      </div>
                    </div>
                    <!-- End progress_inner -->
                    <div class="progress_inner">
                      <span
                        ><span class="label">After Effects</span
                        ><span class="number">70%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:70%"></div>
                        </div>
                      </div>
                    </div>
                    <!-- End progress_inner -->
                  </div>
                  <!-- End .tokyo_progress -->
                </div>
                <!-- End .left -->
                <div class="right">
                  <div class="about_title">
                    <h3>Web Languages</h3>
                  </div>
                  <div class="tokyo_progress">
                    <div class="progress_inner">
                      <span
                        ><span class="label">HTML</span
                        ><span class="number">70%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:70%"></div>
                        </div>
                      </div>
                    </div>
                    <div class="progress_inner">
                      <span
                        ><span class="label">CSS</span
                        ><span class="number">70%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:70%"></div>
                        </div>
                      </div>
                    </div>
                    <div class="progress_inner">
                      <span
                        ><span class="label">JavaScript</span
                        ><span class="number">50%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:50%"></div>
                        </div>
                      </div>
                    </div>
                    <div class="progress_inner">
                      <span
                        ><span class="label">Vue.js</span
                        ><span class="number">50%</span></span
                      >
                      <div class="background">
                        <div class="bar">
                          <div class="bar_in" style="width:50%"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End .right -->
              </div>
              <div class="counter">
                <div class="about_title">
                  <h3>Fun Facts</h3>
                </div>
                <ul>
                  <li>
                    <div class="list_inner">
                      <h3>11+ years</h3>
                      <span>Design industry</span>
                    </div>
                  </li>
                  <li>
                    <div class="list_inner">
                      <h3>Other Skills</h3>
                      <span>Agile / SASS / Git /</span>
                    </div>
                  </li>
                  <li>
                    <div class="list_inner">
                      <h3>2 Languages</h3>
                      <span>Spanish / English </span>
                    </div>
                  </li>
                </ul>
                <!-- End ul -->
              </div>
              <!-- End .counter -->
              
              <!-- End .partner -->
            </div>
            <!-- End .tokyo_tm_modalbox_about -->
          </div>
        </div>
      </div>
    </transition>
    <!-- End Modalbox -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      isVisible: false,
    };
  },
  methods: {
    showModal: function() {
      this.isActive = true;
      this.isVisible = true;
    },
    closeModal: function() {
      this.isActive = false;
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss"></style>
